import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-checked';
	$(base, context).each(function(){
		var component = $(this);
		var checkItem = component.find(base + '-item');
		var checkAll = component.find(base + '-all');
		var singleChecked = component.find(base + '-single:checked').length;

		function parentHandle(parent, child) {
			parent.on('click', function() {
				parent.removeClass('m-minus');
				child.removeClass('m-minus');
				child.prop("checked", !!this.checked);

				singleChecked = component.find(base + '-single:checked').length;
			});
		}

		function childrenHandle(parent, child, elChecked, el) {
			child.click(function() {
				singleChecked = component.find(base + '-single:checked').length;

				if ($(el).find(elChecked).length == child.length) {
					parent.prop('checked', true);
					parent.removeClass('m-minus');
				} else {
					parent.prop('checked', false);
					parent.addClass('m-minus');
				}
				
				if ($(el).find(elChecked).length == 0) {
					parent.removeClass('m-minus');
				}
			});
		}

		checkItem.each(function(i, el) {
			var checkSingle = $(el).find(base + '-single');
			var checkGroup = $(el).find(base + '-group');

			parentHandle(checkGroup, checkSingle);
			childrenHandle(checkGroup, checkSingle, base + '-single:checked', el);
		});

		var checkGeneral = component.find(base + '-general');

		parentHandle(checkAll, checkGeneral);
		childrenHandle(checkAll, checkGeneral, base + '-general:checked', base);

		var filterCount = $('.i-filterCount');
		filterCount.text(singleChecked);

		$('.i-checkBtn').on('click', function(e) {
			e.preventDefault();
			filterCount.text(singleChecked);
		});
	});
});